<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 14 14"
  >
    <g
      id="Icon_ionic-ios-checkmark-circle-outline"
      data-name="Icon ionic-ios-checkmark-circle-outline"
      transform="translate(-3.375 -3.375)"
    >
      <path
        id="Path_651"
        data-name="Path 651"
        d="M17.643,12.856l-.592-.609a.127.127,0,0,0-.094-.04h0a.122.122,0,0,0-.094.04l-4.106,4.136-1.494-1.494a.13.13,0,0,0-.188,0l-.6.6a.134.134,0,0,0,0,.192l1.885,1.885a.6.6,0,0,0,.394.192.625.625,0,0,0,.39-.185h0l4.5-4.523A.144.144,0,0,0,17.643,12.856Z"
        transform="translate(-3.681 -4.604)"
        fill="#f88695"
      />
      <path
        id="Path_652"
        data-name="Path 652"
        d="M10.375,4.317A6.055,6.055,0,1,1,6.091,6.091a6.018,6.018,0,0,1,4.284-1.774m0-.942a7,7,0,1,0,7,7,7,7,0,0,0-7-7Z"
        fill="#f88695"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-4'
    },
    height: {
      type: String,
      default: 'h-4'
    }
  }
}
</script>
